import { css } from 'styled-components'

import { mq } from './mq'
import { theme } from './theme'

export const textBase = css`
  font-family: ${theme.fonts.body};
  font-weight: normal;
  font-optical-sizing: auto;
  line-height: 160%;
`

const headingBase = css`
  font-family: ${theme.fonts.headings};
  font-weight: normal;
  font-optical-sizing: auto;
  text-transform: uppercase;
  font-weight: 100;
  letter-spacing: 0.2em;
  line-height: 1.2;
`

export const typography = {
  text: {
    sm: css`
      ${textBase}
      font-size: 1.2rem;
      line-height: 1.2;

      ${mq.large} {
        font-size: 1.4rem;
      }
    `,
    md: css`
      ${textBase}
      font-size: 1.5rem;

      ${mq.large} {
        font-size: 1.6rem;
      }
    `,
  },
  heading: {
    h1: css`
      ${headingBase}
      font-size: clamp(3rem, 12vw, 7.2rem);

      ${mq.large} {
        font-size: 7.2rem;
      }
    `,
    h2: css`
      ${headingBase}
      font-size: clamp(3rem, 9vw, 6.4rem);
    `,
    h3: css`
      ${textBase}
      font-weight: 500;
      font-size: 2rem;
    `,
  },
}
